
import extend from '@/utils/vuex-extend';
import { table, dialog } from '@/vuex-extend';
import { getAssignSupplierList, getAssignedList, assignSupplier } from '@/api/ums/assign-supplier';
import { wait } from '@/utils/wait';
import { Message } from 'element-ui';

export default extend(dialog, table, {
    namespaced: true,
    state: {
        id: 0,
        multipleSelection: [],
        allChecked: false
    },
    actions: {
        async afterOpenDialog({ dispatch, commit, state }, payload) {
            await wait(dispatch, 'ums.admin.assign-supplier.assined-ids', async function() {
                const { id } = state;
                const assignedResponse = await getAssignedList(id);
                if (assignedResponse.data) {
                    commit('save', {
                        multipleSelection: assignedResponse.data.supplierIds
                    })
                }
                await dispatch('getAssignSupplierList');
            })
        },
        async getAssignSupplierList({ commit, dispatch, state }, payload) {
            await wait(dispatch, 'ums.admin.assign-supplier.list', async function() {
                await dispatch('getData', {
                    caller: getAssignSupplierList,
                    options: payload
                });
                commit('checkedAll')
            })
        },
		async confirm({ commit, state, dispatch }) {
            const { id, multipleSelection } = state;
            await wait(dispatch, 'ums.admin.assign-supplier.confirm', async function () {
                const response = await assignSupplier(id, {
                    suppIdList: multipleSelection
                })
                if (response.data) {
                    Message.success('分配成功');
                    dispatch('closeDialog');
                    dispatch('umsAdminList/getList', {}, {root: true});
                }
            })
		}
    },
    mutations: {
        checkedAll(state, payload) {
            const { list, multipleSelection } = state;
            let allChecked = true;
            list.map((v) => {
                if (!multipleSelection.includes(v.suppId)) {
                    allChecked = false;
                }
            })
            Object.assign(state, {
                allChecked
            });
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/ums/admin/assign-supplier.js